<template>
  <a-layout>
    <Breadcrumb />
    <div class="page-title-container">
      <span class="page-title">用户信息</span>
    </div>
    <div class="content-container">
      <div class="container">
        <div class="steps-content">
          <div class="field-container">
            <div class="field-label-container">
              <span class="field-label field-label__bold">用户名</span>
            </div>
            <div class="field-content">
              {{ user.userName }}
            </div>
          </div>
          <div class="field-container">
            <div class="field-label-container">
              <span class="field-label field-label__bold">姓名</span>
            </div>
            <div class="field-content">
              {{ user.realName }}
            </div>
          </div>
          <div class="field-container">
            <div class="field-label-container">
              <span class="field-label field-label__bold">手机</span>
            </div>
            <div class="field-content">
              {{ user.mobile }}
            </div>
          </div>
          <div class="field-container">
            <div class="field-label-container">
              <span class="field-label field-label__bold">角色</span>
            </div>
            <div class="field-content">
              {{ user.roleNames }}
            </div>
          </div>
          <div class="field-container">
            <div class="field-label-container">
              <span class="field-label field-label__bold">密码</span>
            </div>
            <div class="field-content">
              <span>已设置</span>
              <a @click="changePwdVisible = true" style="margin-left: 40px;">修改密码</a>
            </div>
          </div>
        </div>

      </div>
    </div>
    <a-modal
        :visible="changePwdVisible"
        title="修改密码"
        okText="确定"
        cancelText="取消"
        @ok="startChangePwd"
        @cancel="changePwdVisible = false"
    >
      <div class="input-container">
        <span class="pwd-label">旧密码</span><a-input v-model="oldPassword" type="password" placeholder="请输入旧密码" class="pwd-input" />
      </div>
      <div class="input-container">
        <span class="pwd-label">新的密码</span><a-input v-model="newPassword" type="password" placeholder="请输入新密码" class="pwd-input" />
      </div>
      <div class="input-container">
        <span class="pwd-label">重复新密码</span><a-input v-model="confirmPassword" type="password" placeholder="请再次输入新密码" class="pwd-input" />
      </div>
    </a-modal>
  </a-layout>
</template>
<script>
import Breadcrumb from "@/components/Breadcrumb.vue";
import BreadcrumbItem from "@/components/BreadcrumbItem.vue";
import {loadUser, changePwd} from "@/services/UserService";

export default {
  components: {BreadcrumbItem, Breadcrumb },
  data() {
    return {
      user: {
        userId: "",
        realName: "",
      },
      changePwdVisible: false,
      oldPassword:"",
      newPassword:"",
      confirmPassword:"",

    };
  },
  created() {
    this.user.userId = localStorage.getItem("userId");
  },
  mounted() {
    this.startLoadProfile();
  },
  methods: {
    startLoadProfile(){
      if (this.user.userId && this.user.userId !== "") {
        loadUser(this.user.userId).then(resp => {
          if (resp.data.code === "SUCCESS") {
            this.user = resp.data.data;
            if(this.user.roleNames && this.user.roleNames.length>0) {
              this.user.roleNames = this.user.roleNames.join(", ");
            }
          } else {
            this.$message.error("读取用户信息失败");
          }
        });
      }
    },
    startChangePwd() {
      let validationMsg = this.validatePwdInput();
      if(validationMsg!==""){
        this.$message.error(validationMsg);
      } else {
        let params = {
          oldPwd: this.oldPassword,
          newPwd: this.newPassword
        };
        console.log(params);
        changePwd(params).then(resp => {
            if (resp.data.code === "SUCCESS") {
              this.$message.success("操作成功");
              this.changePwdVisible = false;
            }
          })
          .catch(error => {
            console.log("error api:" + error);
          });
      }
    },
    validatePwdInput(){
      if(!this.oldPassword){
        return"请输入旧密码";
      }
      if(!this.newPassword){
        return"请输入新密码";
      }
      if(!this.confirmPassword){
        return "请再次输入新密码";
      }
      if(this.newPassword !== this.confirmPassword){
        return "两次输入的新密码不一致";
      }
      return "";
    }

  }
}
</script>
<style scoped>
.container {
  width: 100%;
  background-color: white;
  box-sizing: border-box;
  padding: 28px 32px;
  display: flex;
  flex-direction: column;
}
.field-container {
  padding-bottom: 12px;
}
.field-label-container {
  padding-top: 10px;
  padding-bottom: 10px;
  color: rgba(0, 0, 0, 0.85)
}
.field-label {
  margin-left: 4px;
}
.input-container{
  padding-top: 4px;
  padding-bottom: 4px;
}
.pwd-label {
  display: inline-block;
  width: 100px;
  margin-right: 10px;
}
.pwd-input {
  width: 200px;
}
</style>
